import { useEffect, useMemo, useRef } from "react";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import Chart from "chart.js/auto";
import Loading from "src/components/Loading";
import AuditEmplyeesTableSingle from "./AuditEmplyeesTableSingle";

export default function AuditEmplyeesSingle({
  auditItems,
  setAuditItems,
  view,
  setExportData,
  loading,
  setQuery,
  query,
  cardVersion,
}: any) {
  useEffect(() => {
    return () => {
      setAuditItems([]);
    };
  }, []);

  const CircularChartUI = ({
    percentage = { completed: 0, uncompleted: 0, cancelled: 0 },
  }: {
    percentage?: { completed: number; uncompleted: number; cancelled: number };
  }) => {
    const chartRef = useRef<HTMLCanvasElement | null>(null);
    const chartInstance = useRef<Chart | null>(null);

    useEffect(() => {
      const ctx = chartRef.current!.getContext("2d");
      const options = {
        maintainAspectRatio: false,
        responsive: true,
        cutout: "70%", // Размер внутреннего радиуса (создание толщины кольца)
        rotation: 0, // Поворот на 90 градусов, чтобы заполнение шло сверху
        circumference: 360, // Полный круг
        animation: {
          animateRotate: true,
          duration: 1000,
        },
        plugins: {
          tooltip: {
            enabled: false, // Отключить тултипы
          },
          legend: {
            display: false, // Скрыть легенду
          },
          datalabels: {
            display: false,
          },
        },
      };

      if (!chartInstance.current) {
        chartInstance.current = new Chart(ctx!, {
          type: "doughnut",
          data: {
            labels: [],
            datasets: [{
              data: [
                percentage.completed,
                percentage.uncompleted,
                percentage.cancelled
              ],
              backgroundColor: ["#5475E5", "#E1E8FF", "#18BFFF"],
              borderWidth: 0
            }]
          },
          options
        });
      } else {
        chartInstance.current.data.datasets[0].data = [
          percentage.completed,
          percentage.uncompleted,
          percentage.cancelled
        ];
        chartInstance.current.update();
      }
    }, [percentage]);

    useEffect(() => {
      return () => {
        chartInstance.current?.destroy();
      };
    }, []);

    return (
      <div className="max-w-[108px] max-h-[108px] rotate-45">
        <canvas ref={chartRef} />
      </div>
    );
  };

  const CircularChart = ({
    countOfAudit,
  }: {
    countOfAudit: { completed: number; uncompleted: number; cancelled: number };
  }) => {

    const percentage = useMemo(() => {
      const total = countOfAudit.completed + countOfAudit.uncompleted;

      return {
        completed: (countOfAudit.completed / total) * 100,
        uncompleted: (countOfAudit.uncompleted / total) * 100,
        cancelled: (countOfAudit.cancelled / total) * 100,
      };
    }, [countOfAudit]);

    return <CircularChartUI percentage={percentage} />;
  };

  return (
    <>
      <FlexRow className="px-7.5 py-7.5 justify-center space-x-[15px] shadow-custom bg-white w-full rounded">
        <FlexCol className="items-center justify-center">
          {(!loading && (
            <CircularChart
              countOfAudit={{
                completed: auditItems.filter((item: any) => item.Completed)
                  .length,
                uncompleted: auditItems.filter((item: any) => !item.Completed)
                  .length,
                cancelled: auditItems.filter((item: any) => item.Title.indexOf("Отклонено") !== -1)
                  .length,
              }}
            />
          )) || (
              <FlexCol className="mr-5">
                <Loading />
              </FlexCol>
            )}
        </FlexCol>
        <FlexCol>
          <div>
            <h5 className="font-medium text-black">Уровень ознакомлений</h5>
            <div className="flex items-center mt-2.5">
              <span className="block w-1 h-4 mr-2 bg-[#5475E5] rounded-full"></span>
              <p>
                {(auditItems.filter((item: any) => item.Completed).length > 0 &&
                  Math.round(
                    (auditItems.filter((item: any) => item.Completed).length /
                      auditItems.length) *
                    100
                  )) ||
                  "0"}
                % ({auditItems.filter((item: any) => item.Completed).length})
                завершенных ознакомлений
              </p>
            </div>
            <div className="flex items-center mt-1">
              <span className="block w-1 h-4 mr-2 bg-[#E1E8FF] rounded-full"></span>
              <p>
                {(auditItems.filter((item: any) => !item.Completed).length >
                  0 &&
                  Math.round(
                    (auditItems.filter((item: any) => !item.Completed).length /
                      auditItems.length) *
                    100
                  )) ||
                  "0"}
                % ({auditItems.filter((item: any) => !item.Completed).length})
                незавершенных ознакомлений
              </p>
            </div>
            <div className="flex items-center mt-1">
              <span className="block w-1 h-4 mr-2 bg-[#18BFFF] rounded-full"></span>
              <p>
                {(auditItems.filter((item: any) => item.Title.indexOf("Отклонено") !== -1).length >
                  0 &&
                  Math.round(
                    (auditItems.filter((item: any) => item.Title.indexOf("Отклонено") !== -1).length /
                      auditItems.length) *
                    100
                  )) ||
                  "0"}
                % ({auditItems.filter((item: any) => item.Title.indexOf("Отклонено") !== -1).length})
                отклоненных ознакомлений
              </p>
            </div>
          </div>
        </FlexCol>
      </FlexRow>
      <AuditEmplyeesTableSingle
        setExportData={setExportData}
        data={auditItems}
        setQuery={setQuery}
        cardVersion={cardVersion}
        query={query}
      />
    </>
  );
}
